import { defineMessages } from 'react-intl';

export default defineMessages({
  dotSelected: { id: 'gofre.carrousel.dot.selected' },
  dotNotSelected: { id: 'gofre.carrousel.dot.notselected' },
  dotContact: { id: 'gofre.carrousel.dot.contact' },
  dotTo: { id: 'gofre.carrousel.dot.to' },
  title: { id: 'gofre.carrousel.header.title' },
});
